import { GlobalSettings, RuntimeEnvironmentKey } from "../global_settings.js";

const WEB_ENDPOINTS: Record<RuntimeEnvironmentKey, string> = {
  [RuntimeEnvironmentKey.MAIN]: 'https://crashlytics.blastix.net',
  [RuntimeEnvironmentKey.PROD]: 'https://crashlytics.blastix.net',
};

const WEB_KEYS: Record<RuntimeEnvironmentKey, string> = {
  [RuntimeEnvironmentKey.MAIN]: 'e1ba38b3445c70dc759eee83377c3890',
  [RuntimeEnvironmentKey.PROD]: 'e1ba38b3445c70dc759eee83377c3890',
};

const PLACEHOLDER_PREFIX = 'TODO_';

const isConfigured = ( value: string ): boolean =>
  value.length > 0 && !value.startsWith( PLACEHOLDER_PREFIX );

export const CrashConfig = {
  SNAPSHOT_INTERVAL_MS: 2_000,
  BREADCRUMB_LIMIT: 50,
  MAX_EVENTS_PER_SESSION: 20,
  MAX_CONSOLE_ERRORS_PER_SESSION: 5,
  DEDUPE_WINDOW_MS: 1_000,
  WEB_QUEUE_LIMIT: 20,
  WEB_SEND_TIMEOUT_MS: 8_000,
  MAX_STACK_CHARS: 64 * 1024,
  MAX_MESSAGE_CHARS: 10_000,
  MAX_CAUSE_DEPTH: 5,

  buildId(): string
  {
    return typeof __CRASH_BUILD_ID__ === 'string' && __CRASH_BUILD_ID__.length > 0 ? __CRASH_BUILD_ID__ : 'dev';
  },

  webEndpoint(): string | null
  {
    const override = safeGet( 'crash_endpoint_override' );
    if ( override && isConfigured( override ) ) return override.replace( /\/+$/, '' );
    const value = WEB_ENDPOINTS[GlobalSettings.ENV] ?? WEB_ENDPOINTS[RuntimeEnvironmentKey.MAIN];
    return isConfigured( value ) ? value.replace( /\/+$/, '' ) : null;
  },

  webKey(): string | null
  {
    const override = safeGet( 'crash_key_override' );
    if ( override && isConfigured( override ) ) return override;
    const value = WEB_KEYS[GlobalSettings.ENV] ?? WEB_KEYS[RuntimeEnvironmentKey.MAIN];
    return isConfigured( value ) ? value : null;
  },
};

let query_applied = false;

function applyQueryOverrides(): void
{
  if ( query_applied ) return;
  query_applied = true;
  try
  {
    const params = new URLSearchParams( window.location.search );
    const endpoint = params.get( 'crash_endpoint' );
    const key = params.get( 'crash_key' );
    if ( endpoint !== null ) setOrClear( 'crash_endpoint_override', endpoint );
    if ( key !== null ) setOrClear( 'crash_key_override', key );
  }
  catch {}
}

function setOrClear( storage_key: string, value: string ): void
{
  if ( value ) localStorage.setItem( storage_key, value );
  else localStorage.removeItem( storage_key );
}

function safeGet( key: string ): string | null
{
  applyQueryOverrides();
  try { return localStorage.getItem( key ); }
  catch { return null; }
}
